import { useCallback } from "react"
import { Integration } from "../../../types"
import { buildIntegrationPayload } from "../../integration-new/utils"

interface UseSaveIntegrationArgs {
  saveIntegration: (values: any) => { unwrap: () => Promise<any> }
  pushSuccessToast: (msg: string) => void
  pushErrorToast: (msg: string) => void
}

export const useSaveIntegration = ({
  saveIntegration,
  pushSuccessToast,
  pushErrorToast
}: UseSaveIntegrationArgs) =>
  useCallback(
    (values: Integration) => {
      const postValues = buildIntegrationPayload(values)

      saveIntegration(postValues)
        .unwrap()
        .then(() =>
          pushSuccessToast("Integration has been updated successfully")
        )
        .catch(() => pushErrorToast("Failed to update integration"))
    },
    [saveIntegration, pushSuccessToast, pushErrorToast]
  )
